define(["require", "exports", "react/jsx-runtime", "../../utils/i18n"], function (require, exports, jsx_runtime_1, i18n_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    const I18N = (props) => {
        const { text } = props;
        return jsx_runtime_1.jsx(jsx_runtime_1.Fragment, { children: i18n_1.i18n(text) }, void 0);
    };
    exports.default = I18N;
});
//# sourceMappingURL=I18N.js.map